<template>
  <nav
    v-if="
      $route.path !== '/login' &&
      $route.path !== '/register-diklat' &&
      $route.path !== '/register-marketplace'
    "
  >
    <v-toolbar class="color-gradient-1">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="grey--text hidden-md-and-up"
      ></v-app-bar-nav-icon>
      <v-flex class="ml-2 d-flex">
        <v-img
          max-height="55"
          max-width="55"
          lazy-src="../assets/logo.png"
          src="../assets/logo.png"
          contain
        ></v-img>
        <div>
          <div class="my-text-animation">
            DINAS PEKERJAAN UMUM
          </div>
          <div class="font-weight-black custom-glow" >
            {{ (bidang !==undefined? bidang.description: '') }}
          </div>
        </div>
      </v-flex>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/home">
          <span class="caption font-weight-bold">Home</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          plain
          elevation="0"
          color="gray darken-1"
          route
          :to="`/landing-berita-agenda/${computedBidang.id}`">
          <span class="caption font-weight-bold">Berita-Agenda</span>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/public-market-place"
        >
          <v-icon small>mdi-cart</v-icon>
          <span class="caption font-weight-bold">Market-Place</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
      app
      class="bottom-gradient hidden-sm-and-up"
      v-model="drawer"
    >
      <v-layout column align-center>
        <v-flex class="mt-5">
          <v-img
            lazy-src="../assets/images/logo_sidebar_small.png"
            max-height="220"
            max-width="220"
            src="../assets/images/logo_sidebar_small.png"
          ></v-img>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
      <v-list>
        <v-list-item route to="/home">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item route to="/landing-berita-agenda">
          <v-list-item-icon>
            <v-icon>mdi-rss</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Berita-Agenda</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>

export default {
  name: "MenuBarBidang",
  props: {
    bidang: Object
  },
  data() {
    return {
      drawer: false,
      menu_berita_agenda: [
        { icon: "", title: "Berita", route: "/public_berita", visible: true },
        { icon: "", title: "Agenda", route: "/public_agenda", visible: true },
      ],
      menu_informasi: [
        {
          icon: "",
          title: "Tenaga Kerja",
          route: "/public_tenaga_kerja",
          visible: true,
        },
        {
          icon: "",
          title: "Kontraktor",
          route: "/public_cv_pt",
          visible: true,
        },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    computedBidang(){
      if(this.bidang !== undefined){
        return this.bidang;
      }else {
        return {id:0};
      }
    }
  },
  methods: {
    signIn() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
.my-text-animation {

  font-size: 14px;
  font-weight: bolder;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-align: center;

  background: linear-gradient(to right, #3f51b5, #2196f3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient 5s ease infinite;

  text-transform: uppercase;
  background-image: linear-gradient(
      -225deg,
      #231557 0%,
      #44107a 29%,
      #ff1361 67%,
      #fff800 100%
  );

  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  font-size: 14px;
}
@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

@keyframes flip {
  0%,80% {
    transform: rotateY(360deg)
  }
}

.custom-glow {
  font-size: 20px; /* Sesuaikan ukuran teks sesuai kebutuhan */
  font-weight: bold; /* Sesuaikan ketebalan teks sesuai kebutuhan */
  color: #fff; /* Warna teks */

  /* Efek glow dengan variasi radius dan warna */
  text-shadow: 0 0 10px #00f, 0 0 20px #00f, 0 0 10px #00f;
}
</style>